import * as React from "react";
import { Modal, Button, Tooltip } from "antd";
import ManageUsersForm from "../Form/ManageUsersForm";
import {
  EditOutlined,

  // CloseOutlined,
  // CheckOutlined,
} from "@ant-design/icons";

export const ManageUsersModalContext = React.createContext<{
  setIsModalVisible: (active: boolean) => void;
}>({
  setIsModalVisible: () => true,
});

const UsersManageModal: React.FC<{ id: number }> = ({ id }) => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);

  const showModal = () => setIsModalVisible(true);

  const handleOk = () => setIsModalVisible(false);

  const handleCancel = () => setIsModalVisible(false);

  return (
    <ManageUsersModalContext.Provider value={{ setIsModalVisible }}>
      <Tooltip title="Edit/Update">
        <Button
          onClick={showModal}
          type="primary"
          shape="circle"
          icon={<EditOutlined />}
        />
      </Tooltip>
      <Modal
        title="Manage Users"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <ManageUsersForm id={id} />
      </Modal>
    </ManageUsersModalContext.Provider>
  );
};

export default UsersManageModal;
